























import {Vue, Component} from 'vue-property-decorator';
import {toI18n} from '@/utils/commonUtils';

@Component
export default class DisplayCategoryInfo extends Vue {
  public toI18n(needToI18nStr: string): string {
    return toI18n(this.$t('PRODUCT_POP_PRODUCTLIST_' + needToI18nStr));
  }
  private displayCategory = [];

  private close() {
    window.close();
  }

  private created() {
    document.body.classList.add('popup', 'popup_small');
    this.$api.getProductDisplayCategories({params: {productNo: this.$route.query.mallProductNo as string}}).then(({data}) => {
      this.displayCategory = [...data.map(({displayable, fullCategoryName, displayCategoryNo}: any) => {
        return {displayable, fullCategoryName, displayCategoryNo};
      })];
    });

    window.name = 'displayCategoryNamesWin';
  }
}
